// DEPENDENCIES ---------------------------------------------------------------- //

import { Marker } from '@components/DriverTracker/driverTrackerService';
import { LocationPinBubble, LocationPinMarker } from '@components/Maps';

// TYPES ---------------------------------------------------------------- //

interface DriverTrackerMarkerProps {
  marker?: Marker;
}

// COMPONENT ---------------------------------------------------------------- //

const DriverTrackerMarker = ({ marker }: DriverTrackerMarkerProps) => {
  const lat = marker?.position?.lat;
  const lng = marker?.position?.lng;
  const position = lat != null && lng != null ? { lat, lng } : undefined;

  const rawRole = marker?.id || 'Unknown';
  const bubbleTitle = `${rawRole.charAt(0).toUpperCase()}${rawRole.slice(1)} Location`;

  return (
    <LocationPinMarker
      mapId='driver-tracker-map'
      markerId={marker?.id || 'utility'}
      position={{ lat: lat || 0, lng: lng || 0 }}
      size={48}
      iconSize={28}
      hoverBrighter
    >
      <LocationPinBubble
        markerId={marker?.id}
        title={bubbleTitle}
        name={marker?.name || 'Unknown Name'}
        address={marker?.address || 'Unknown Address'}
        favorited={!!marker?.favorite}
        position={position}
      />
    </LocationPinMarker>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default DriverTrackerMarker;
